import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
import { useHistory } from "routerCompat";
import Header from "../header";
function CitySelection(props) {
  const history = useHistory();
  const [mainCity, setMainCity] = useState([]);
  const [lastName, setLastName] = useState();
  const [loader, setLoader] = useState(true);
  const [userName, setUserName] = useState("");
  useEffect(() => {
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/splash`, {
        headers: Headers,
      })
      .then((res) => {
        setUserName(res.data.customer_info.name);
        setMainCity(res.data.cities);
        setLoader(false);
      });
  }, []);

  const setCity = (item, county) => {
    localStorage.setItem("county", county);
    history.push({
      pathname: "/citySelection/City",
      cities: item,
      name: userName,
    });
  };

  return (
    <>
      {loader ? (
        <Spinner />
      ) : (
        <div className="ChangeCity">
          <Header
            showSearchBar={true}
            title={"انتخاب شهر"}
            isDarkTheme={true}
          />
          <div className="innerChangeCity">
            <div className="selected">
              <input defaultValue={""} value={lastName}></input>
            </div>
            <div className="cityLists">
              {mainCity.map((item) => (
                <>
                  <div
                    className="cityRow"
                    onClick={() => setCity(item.cities, item.name)}
                  >
                    <span className="city">{item.name}</span>
                  </div>
                  <div className="cityDivider" />
                </>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CitySelection;
